import Button from '@base/components/src/Button';
import CheckIcon from '@base/components/src/Icon/CheckIcon';
import Spinner from '@base/components/src/Spinner';
import clsx from 'clsx';
import config from 'config-base';
import { useCallback, useMemo, useState } from 'react';
import { ADD_STATE_TIMEOUT, AddonButtonProps, ButtonState } from './types';
import styles from './AddonButton.module.css';

const AddonButton = ({ onClick, outOfStock = false }: AddonButtonProps) => {
  const [buttonState, setButtonState] = useState<ButtonState>(ButtonState.Add);

  const buttonLabel = useMemo(() => {
    switch (buttonState) {
      case ButtonState.Add:
        return 'Add to Cart';

      case ButtonState.Adding:
        return 'Adding';

      case ButtonState.Added:
        return (
          <>
            <CheckIcon />
            <div className="font-bold">Added</div>
          </>
        );
    }
  }, [buttonState]);

  const handleClick = useCallback(
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      const preventStateChange = buttonState === ButtonState.Adding || buttonState === ButtonState.Added;
      if (preventStateChange) return;

      if (outOfStock) return await onClick();

      setButtonState(ButtonState.Adding);
      await onClick();
      setButtonState(ButtonState.Added);
      setTimeout(() => {
        setButtonState(ButtonState.Add);
      }, ADD_STATE_TIMEOUT);
    },
    [buttonState],
  );

  return (
    <Button
      label={buttonLabel}
      classes={clsx(styles.addonButton, {
        [styles.addonButtonAdding]: buttonState === ButtonState.Adding,
        'addonButtonAdded': buttonState === ButtonState.Added,
        [styles.addonButtonAGD]: config.brandCode !== '0',
      })}
      onClick={handleClick}
      size={'medium'}
      endIcon={buttonState === ButtonState.Adding ? <Spinner /> : null}
      data-testid="addon-button-add"
    />
  );
};

export default AddonButton;
